/**
 * Normalização do envelope de resposta da fila de sugestões.
 *
 * Vive fora da classe de API porque é lógica com caso de borda real, e `guidelines/tests.md`
 * manda extrair pra util o que precisa de `.unit.js` próprio — arquivo de API não tem teste seu.
 *
 * O motivo de existir: `services/connection.js` devolve `{}` quando a sessão expira, e um envelope
 * anômalo caindo direto no `buildErrorResponse` viraria `status: undefined` na tela. Aqui qualquer
 * upstream inválido colapsa num erro completo, e um upstream válido é preservado como veio.
 */
export const MENSAGEM_ERRO_PADRAO =
  'Não foi possível carregar as sugestões da IA.'

export const envelopeDeErro = (resposta) => ({
  status: (resposta && resposta.status) || 500,
  message: (resposta && resposta.message) || MENSAGEM_ERRO_PADRAO,
  value: null,
})

export const listaDaResposta = (resposta) => {
  const temValor = resposta && resposta.status === 200 && resposta.value
  const lista = temValor && resposta.value.suggestions
  return Array.isArray(lista) ? lista : []
}
